import { setComponentMapOverrides } from '@jutro/uiconfig';

import FNOLSelectPolicy from './pages/FNOLSelectPolicy/FNOLSelectPolicy';


setComponentMapOverrides(
    { FNOLSelectPolicy: { component: 'FNOLSelectPolicy' } },
    { FNOLSelectPolicy }
);

export { FNOLSelectPolicy as default };
